module.exports = __webpack_public_path__ + "static/media/w (12).4b2d148c.jpg";